import React, { useState } from "react";
import { Button, Input, message, Form } from "antd";
import { Auth } from "aws-amplify";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Rules } from "../../common/AsyncValid";
import "./Login.scss";
import { useHistory } from "react-router";

export const Forgot = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const history = useHistory();

  const onSave = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      const { username, code, password } = values;
      if (showAll) {
        Auth.forgotPasswordSubmit(username, code, password)
          .then((res) => {
            message.success("Your password had saved!");
            history.push("/login");
          })
          .catch((err) => {
            message.error(err.message);
          })
          .finally(() => setLoading(false));
      } else {
        Auth.forgotPassword(username)
          .then((res) => {
            message.success("The confirm code has send to your email");
            setShowAll(true);
          })
          .catch((err) => {
            message.error(err.message);
          })
          .finally(() => setLoading(false));
      }
    });
  };

  return (
    <div className="login-page">
      <div className="login-form">
        <header style={{ textAlign: "center" }}>
          <h1>FooMoo Admin</h1>
          <h4>Forgot Password</h4>
        </header>
        <Form form={form}>
          <Form.Item name="username" rules={Rules.email}>
            <Input placeholder="Enter your email" prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />} />
          </Form.Item>
          {showAll && (
            <>
              <Form.Item name="password" rules={[{ required: true }]}>
                <Input.Password
                  placeholder="Enter your new password"
                  prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                />
              </Form.Item>
              <Form.Item name="code" rules={[{ required: true }]}>
                <Input placeholder="Enter your code" prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />} />
              </Form.Item>
            </>
          )}
          <Form.Item>
            <Button loading={loading} onClick={onSave} block type="primary">
              Submit
            </Button>
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            <span onClick={() => history.push("/login")}>I have password</span>
          </div>
        </Form>
      </div>
    </div>
  );
};
